import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialEcomsyncItemContainerModel} from '../../../../../../models/aggregates/erp/financial';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemPricingStockBalanceService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items-pricing-stock-balance';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items-pricing-stock-balance';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items-pricing-stock-balance';
    this.httpClient = http;
  }

  scanItem(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<any>> {
    let url = this.apiUrl + '/backoffice-ep/scan-items';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/scan-items' + '?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getItemsByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
